export default function Contact() {
  return (
    <section className="sec" id="contact">
      <div className="wrap">
        <div className="sec-head">
          <p className="eyebrow blue">Επικοινωνία</p>
          <h2>Ελάτε να γνωριστούμε.</h2>
          <p>
            Βρισκόμαστε στο κέντρο της Μυτιλήνης. Περάστε από τον χώρο μας ή
            καλέστε μας — είμαστε εδώ για κάθε απορία.
          </p>
        </div>
        <div className="contact-grid">
          <div>
            <div className="info-list">
              <div className="info">
                <span className="ic" aria-hidden="true">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M12 21s-7-5.2-7-11a7 7 0 1 1 14 0c0 5.8-7 11-7 11z" />
                    <circle cx="12" cy="10" r="2.6" />
                  </svg>
                </span>
                <div>
                  <div className="k">Διεύθυνση</div>
                  <div className="v">Ερεσσού 17, Μυτιλήνη</div>
                </div>
              </div>
              <div className="info">
                <span className="ic" aria-hidden="true">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M5 4h3l2 5-2.5 1.5a11 11 0 0 0 5 5L19 13l5 2v3a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z" />
                  </svg>
                </span>
                <div>
                  <div className="k">Τηλέφωνο</div>
                  <div className="v">
                    <a href="tel:+302251054070">22510 54070</a>
                  </div>
                </div>
              </div>
              <div className="info">
                <span className="ic" aria-hidden="true">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <rect x="3" y="5" width="18" height="14" rx="2" />
                    <path d="m3 7 9 6 9-6" />
                  </svg>
                </span>
                <div>
                  <div className="k">Email</div>
                  <div className="v">
                    <a href="mailto:info@praksi.gr">info@praksi.gr</a>
                  </div>
                </div>
              </div>
              <div className="info">
                <span className="ic" aria-hidden="true">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <circle cx="12" cy="12" r="9" />
                    <path d="M12 7v5l3 2" />
                  </svg>
                </span>
                <div>
                  <div className="k">Ώρες λειτουργίας</div>
                  <div className="v">
                    Δευτ.–Παρ. 14:00–21:00
                    <br />
                    Σάββατο 09:00–13:00
                  </div>
                </div>
              </div>
            </div>
            <div className="socials">
              <a
                href="https://www.facebook.com/info.praksi"
                aria-label="Facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M14 9h3V6h-3c-2.2 0-3.5 1.5-3.5 3.7V11H8v3h2.5v7h3v-7H16l.5-3H13.5V9.8c0-.5.2-.8.5-.8z" />
                </svg>
              </a>
              <a
                href="https://instagram.com/frontistirio_praksi"
                aria-label="Instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <rect x="3.5" y="3.5" width="17" height="17" rx="5" />
                  <circle cx="12" cy="12" r="4" />
                  <circle
                    cx="17"
                    cy="7"
                    r="1.2"
                    fill="currentColor"
                    stroke="none"
                  />
                </svg>
              </a>
              <a
                href="https://twitter.com/front_praksi"
                aria-label="Twitter"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18 4h3l-7 8 8 8h-6l-4.5-5L6 20H3l7.5-8.5L3 4h6l4 4.5z" />
                </svg>
              </a>
            </div>
          </div>
          <div className="map">
            <iframe
              title="Χάρτης — Φροντιστήριο Πράξη, Μυτιλήνη"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              src="https://maps.google.com/maps?q=%CE%9C%CF%85%CF%84%CE%B9%CE%BB%CE%AE%CE%BD%CE%B7%2C%20%CE%95%CF%81%CE%B5%CF%83%CF%83%CE%BF%CF%8D%2017&t=m&z=16&output=embed&iwloc=near"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
